import { RouteIdEnum } from 'config/enums'
import DashboardLayout from 'layouts/layouts/DashboardLayout/DashboardLayout'
import ZoneProTable from './ZoneProTable'

const ZoneProIndex = () => {
  return (
    <DashboardLayout
      title={"Gestion des Entrepots"}
      selectedPath={RouteIdEnum.ZonePro}
    >
      <ZoneProTable />
    </DashboardLayout>
  )
}

export default ZoneProIndex